import React, { useLayoutEffect, useRef } from "react";

import { vars as stylingVars } from "@app/styles";

import { SpinnerSizes } from "./style-vars";

export type SpinnerAnimationProps = React.AllHTMLAttributes<HTMLDivElement> & {
  dimensions: number;
};

export const SpinnerAnimation = ({ dimensions, children, className }: SpinnerAnimationProps) => {
  const spinnerRef = useRef<HTMLDivElement>(null);
  const styling = {
    position: "relative",
    display: "inline-block",
    boxSizing: "border-box",
    width: `${dimensions}px`,
    height: `${dimensions}px`,
    border: `${dimensions / SpinnerSizes.factor}px solid ${stylingVars.colorHiveryLightFade}`,
    borderRadius: "50%",
  } as React.CSSProperties;

  useLayoutEffect(() => {
    if (!spinnerRef.current) return;

    const spinnerNode = spinnerRef.current;

    spinnerNode.animate([{ transform: "rotate(0deg)" }, { transform: "rotate(360deg)" }], {
      duration: 500,
      iterations: Infinity,
    });
  }, []);

  return (
    <div ref={spinnerRef} style={styling} className={className}>
      {children}
    </div>
  );
};
